import { Injectable } from '@angular/core';
import { RaintreeResponse } from '../interfaces/raintree-response';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import {
  MemberSearchResponseData,
  OnSubmitUpdateResponseData,
} from '../interfaces/member-search';
import {
  ReachUserWishlistRes,
  ReachWishListResponse,
  UserWishlistResponse,
  WishlistResponse,
} from '../interfaces/wishlist.interface';
import { ApiResponse } from '../interfaces/api-response.interface';

@Injectable({
  providedIn: 'root',
})
export class WishlistService extends ApiService {
  public pinUnpinWishlists(body: any): Observable<any> {
    return this.post<any>(ROUTES.PIN_WISHLIST, {
      body: body
    });
  }
  public fetchWishlists(paramsObj?: any): Observable<WishlistResponse> {
    return this.get<WishlistResponse>(ROUTES.WISHLISTS, {
      params: paramsObj,
    });
  }

  public fetchWishlistsName(paramsObj?: any): Observable<WishlistResponse> {
    return this.get<WishlistResponse>(ROUTES.WISHLISTSNAME, {
      params: paramsObj,
    });
  }

  public fetchUserWishlistDetails(
    paramsObj?: any
  ): Observable<WishlistResponse> {
    return this.get<WishlistResponse>(ROUTES.USER_WISHLIST_DETAILS, {
      params: paramsObj,
    });
  }

  public fetchWishListUsersName(paramsObj?: any): Observable<WishlistResponse> {
    return this.get<WishlistResponse>(ROUTES.WISHLIST_CONTRIBUTERS, {
      params: paramsObj,
    });
  }

  public fetchFavorites(paramsObj: {
    uiState: any;
    uiDistrict: any;
    printAll?: boolean;
  }): Observable<any> {
    return this.get<any>(ROUTES.FAVOURITES, {
      params: paramsObj,
    });
  }
  public fetchUserWiseData(
    paramasObj: any
  ): Observable<any> {
    return this.get<any>(ROUTES.STAGNANT_WISHLIST_REPORT, {
      params: paramasObj,
    });
  }
  public fetchStagnantData(
    paramasObj: any
  ): Observable<any> {
    return this.get<any>(ROUTES.STAGNANT_REPORT, {
      params: paramasObj,
    });
  }
  public fetchReachWishlists(): Observable<ReachWishListResponse> {
    return this.get<ReachWishListResponse>(ROUTES.REACH_WISHLISTS);
  }
  public fetchPhaseTwoWishList(data: any, id: any): Observable<any> {
    return this.get<any>(this.replacePathInfo(ROUTES.PHASE_TWO_WISHLIST, {
      id: id
    }), {
      params: data
    })
  }
  public addWishlist(bodyObj: any): Observable<ApiResponse> {
    return this.post<ApiResponse>(ROUTES.WISHLISTS, {
      body: bodyObj,
    });
  }
  public createWishlist(bodyObj: any): Observable<ApiResponse> {
    return this.post<ApiResponse>(ROUTES.CREATE_WISHLIST, {
      body: bodyObj,
    });
  }
  public UpdateWishlist(bodyObj: any): Observable<ApiResponse> {
    return this.patch<ApiResponse>(ROUTES.UPDATE_WISHLIST, {
      body: bodyObj,
    });
  }
  public delWishlist(bodyObj: any): Observable<ApiResponse> {
    return this.post<ApiResponse>(ROUTES.DELETE_WISHLIST_NAME, {
      body: bodyObj,
    });
  }
  public delWishlistItem(bodyObj: any): Observable<ApiResponse> {
    return this.post<ApiResponse>(ROUTES.DELETE_WISHLIST_ITEM, {
      body: bodyObj,
    });
  }
  public editReachWishList(id: number, reqBody: any): Observable<any> {
    return this.patch<any>(
      this.replacePathInfo(ROUTES.EDIT_REACH_WISHLIST, {
        id: id,
      }),
      {
        body: reqBody,
      }
    );
  }

  public editWishList(id: number, reqBody: any): Observable<any> {
    return this.patch<any>(
      this.replacePathInfo(ROUTES.EDIT_WISHLIST, {
        id: id,
      }),
      {
        body: reqBody,
      }
    );
  }
  public delPmWishlist(id: number, reqBody: any): Observable<any> {
    return this.delete<any>(
      this.replacePathInfo(ROUTES.EDIT_WISHLIST, {
        id: id,
      }),
      {
        params: reqBody,
      }
    );
  }
  public delPmWishlistData(
    memberId: any,
    id: number,
    reqBody: any
  ): Observable<any> {
    return this.delete<any>(
      this.replacePathInfo(ROUTES.DELETE_PM_WISHLIST_DATA, {
        id: id,
        memberId: memberId,
      }),
      {
        params: reqBody,
      }
    );
  }
  public deleteWishList(wishlistId: any): Observable<any> {
    return this.delete<any>(
      this.replacePathInfo(ROUTES.DELETE_WISHLIST, {
        wishlistId: wishlistId,
      })
    );
  }

  public deletePHLWishList(
    wishlistId: number,
    paramsObj: any
  ): Observable<any> {
    return this.delete<any>(
      this.replacePathInfo(ROUTES.DELETE_WISHLIST, {
        wishlistId: wishlistId,
      }),
      {
        params: paramsObj,
      }
    );
  }

  public deleteReachWishList(reqBody: any): Observable<any> {
    return this.delete<any>(
      this.replacePathInfo(ROUTES.DELETE_REACH_WISHLIST, {
        wishlistId: reqBody,
      })
    );
  }
  public deleteDataInWishList(reqBody: any): Observable<any> {
    return this.delete<any>(
      this.replacePathInfo(ROUTES.DELETE_DATA_WISHLIST, {
        id: reqBody,
      })
    );
  }
  public addReachWishlist(bodyObj: any): Observable<ApiResponse> {
    return this.post<ApiResponse>(ROUTES.ADD_REACH_WISHLIST, {
      body: bodyObj,
    });
  }
  public addDataReachWishlist(reqBody: any): Observable<any> {
    return this.post<any>(ROUTES.ADD_DATA_IN_REACH_WL, {
      body: reqBody,
    });
  }
  public fetchUserWishlist(
    wishlistId: number,
    paramsObj: any
  ): Observable<UserWishlistResponse> {
    return this.get<UserWishlistResponse>(
      this.replacePathInfo(ROUTES.USER_WISHLIST, {
        wishlistId: wishlistId,
      }),
      {
        params: paramsObj,
      }
    );
  }

  public fetchReachUserWishlist(
    wishlistId: number
  ): Observable<ReachUserWishlistRes> {
    return this.get<ReachUserWishlistRes>(
      this.replacePathInfo(ROUTES.REACH_USER_WISHLIST, {
        id: wishlistId,
      })
    );
  }

  public deleteUserWishlist(
    wishlistId: number,
    memberCode: string,
    paramsObj: any
  ): Observable<any> {
    return this.delete<any>(
      this.replacePathInfo(ROUTES.DELETE_USER_WISHLIST, {
        wishlistId: wishlistId,
        memberCode: memberCode,
      }),
      {
        params: paramsObj,
      }
    );
  }

  public deleteFavoritesUserWishlist(memberCode: string): Observable<any> {
    return this.delete<any>(
      this.replacePathInfo(ROUTES.DELETE_FAVORITES_USER_WISHLIST, {
        memberCode: memberCode,
      })
    );
  }

  public inactiveWishlistItem(memKey: string): Observable<any>{
     return this.post<any>(
      this.replacePathInfo(ROUTES.INACTIVE_WISHLIST_USER, {
        memKey: memKey,
      })
    );
  }
}
